module.exports = __webpack_public_path__ + "static/media/logo-fpi-2-2-18.698d52bd.png";